import React, { Component } from 'react';
import DepenseGrid from '../components/DepenseGrid';


class  Depense extends Component  {


  render() {
 
  
        return ( 
            
            <section className="services-section-four">

                <div className='auto-container'>
                  
                        
                        <DepenseGrid />
                   


                </div>

            </section>
        )
    }
  }

export default Depense

